import React, { useState, useRef } from 'react';
import { 
  ShieldCheck, Zap, Brain, HeartPulse, Activity, Microscope, 
  ChevronRight, CheckCircle2, ArrowRight, Globe2, Factory, Phone, Sparkles, Loader2, AlertCircle 
} from 'lucide-react';

// ⚠️ 1. 请在此处填入您刚刚申请到的 Gemini API Key (以 AIzaSy 开头)
const apiKey = "AIzaSyCVpiyEpO2gwfT55E6U00UCiQJqeD2IezU"; 

const translations = {
  en: {
    nav: { science: "The Science", benefits: "Benefits", ecosystem: "Ecosystem", quality: "Quality & Labs", company: "About WHI", order: "Order Now", switch: "中文" },
    hero: { badge: "AI-Empowered Dual-Pathway Synergy", title1: "A Cellular-Level", titleHighlight: "Anti-Aging", title2: "Formula.", desc: "Support the fundamental characteristics of life—metabolism—with the definitive formulation of AKG, NMN, NR, and NAC.", btnOrder: "Get AI AKG PLUS", btnQuiz: "Take Match Quiz" },
    science: {
      title: "Rejecting the \"Either/Or\" Fallacy", desc: "Both AKG and NMN are complementary and indispensable in supporting your cellular energy and maintenance network.",
      engines: [
        { title: "Core Engine 1: Ca-AKG", sub: "Energy Mineral Reserve", color: "#10b981", points: ["TCA Cycle Hub: Supports natural ATP energy generation.", "Epigenetic Support: Helps maintain a youthful epigenetic profile.", "Tissue Health: Promotes collagen synthesis naturally."] },
        { title: "Core Engine 2: NMN & NR", sub: "Cellular Power Generation", color: "#f59e0b", points: ["Activate Sirtuins: Supports cellular lifespan pathways.", "Cellular Integrity: Provides fuel to support natural DNA maintenance.", "Mitochondrial Function: Supports energy conversion and vitality."] }
      ]
    },
    quality: {
      title: "Quality & Science Transparency", desc: "We believe in absolute transparency. Every batch undergoes rigorous third-party laboratory testing to guarantee purity, potency, and safety.",
      steps: [
        { title: "Premium Sourcing", desc: "We source only the highest-grade raw materials, meticulously verified for authenticity before formulation." },
        { title: "Third-Party HPLC Testing", desc: "Independent lab verification ensures our ingredients consistently meet strict 99%+ purity standards." },
        { title: "Contaminant Free", desc: "Rigorous screening for heavy metals, microbes, and allergens to ensure uncompromised safety." }
      ]
    },
    benefits: {
      title: "Holistic Cellular-Level Support", desc: "Five major dimensions empowered by AI big data screening, NAC cellular defense, and proprietary peptide blends.",
      items: [
        { title: "Neurology & Sleep", desc: "Supports neurotransmitter balance, cognitive function, and facilitates restful sleep via botanical extracts.", icon: Brain },
        { title: "Cellular Vitality", desc: "Promotes healthy cellular responses and supports telomere integrity.", icon: Activity },
        { title: "Energy & Metabolism", desc: "Supports ATP generation and helps maintain dynamic metabolic network balance.", icon: Zap },
        { title: "Cardiovascular Health", desc: "Supports vascular elasticity and provides potent antioxidant defense.", icon: HeartPulse },
        { title: "Muscle & Bone", desc: "Supports muscle vitality, promotes collagen synthesis, and aids in post-activity recovery.", icon: ShieldCheck }
      ]
    },
    ecosystem: {
      title: "DR. FARGO Product Ecosystem", desc: "Internal tuning & external nourishment to support a comprehensive health routine.", coreHub: "Core Internal Hub",
      products: [
        { img: "c4847fc64eb64258fe4316e35982abaa.jpg", title: "High Energy Hair Dryer", desc: "Far Infrared technology releases vital light waves" },
        { img: "c1861705bb8d6698e83eef8ceadb3c9a.jpg", title: "Energy Water Wafer", desc: "Deeply activates water molecules for absorption" },
        { img: "624577b65a79ebb1eb0abf6b598472de.jpg", title: "Photon Detox Bag", desc: "Systemic microcirculation & wellness support" },
        { img: "6ad134ca90efd9a341fdeb20450014f8.png", title: "Collagen Mask", desc: "Deep cell hydration" },
        { img: "ceb922bf426544209c2fa588c474fd83.jpg", title: "Energy Insoles", desc: "Foot acupoint stimulation" }
      ]
    },
   video: { 
      title: "Discover Our Vision", 
      desc: "Explore the science behind DR. FARGO and get to know World Health International.",
      vid1Title: "DR. FARGO AI AKG PLUS",
      vid2Title: "About World Health International" 
    },
    quiz: {
      step: "Step", of: "of", completed: "Completed", resultTitle: "You're a Perfect Match!", btnUnlock: "Unlock Your Formula Now", btnRetake: "Retake Quiz",
      q4Title: "Specific health focus?", q4Placeholder: "e.g., maintaining energy, supporting sleep...", btnGenerateAI: "✨ Generate AI Health Report", generating: "AI is analyzing your cellular profile...", aiResultTitle: "✨ Your Personalized AI Cellular Analysis", aiError: "AI Generation failed. Please check your API key or try again.",
      questions: [
        { q: "What is your primary focus for healthy aging?", opts: ["Boosting daily energy levels", "Supporting deep sleep & cognition", "Physical recovery & joint health", "Overall cellular vitality"] },
        { q: "How often do you experience mid-day fatigue?", opts: ["Rarely - I have steady energy", "Sometimes - usually in the afternoon", "Often - it affects my productivity", "Daily - I constantly feel drained"] },
        { q: "Are you currently taking health supplements?", opts: ["Yes, but taking multiple pills is exhausting", "Yes, but looking for better synergistic results", "No, I don't know where to start", "No, waiting for an all-in-one solution"] }
      ]
    },
    pricing: { 
      title: "Invest in Your Cellular Future", 
      subtitle: "120 Capsules / 30 Servings",
      stock: "In Stock",
      features: [
        "Ca-AKG (1360 mg) + NMN/NR Dual Engine",
        "NAC Cellular Defense Moat",
        "Proprietary Peptide Blend",
        "Targeted Botanical Support"
      ],
      btnAdd: "Checkout with Stripe",
      secure: "Secure SSL Encrypted Payment via Stripe"
    },
    company: { title: "Backed by World Help International Inc.", desc: "Delivering Health • Sowing Hope • Sharing Love. WHI is redefining the global health ecosystem.", boxTitle: "Dual-Core Drive: Redefining Standards", boxDesc: "Integrating Internal Life Power with External Energy Wearables.", features: [{ title: "FDA-Standard Manufacturing", desc: "Fully automated, CGMP compliant facilities." }, { title: "Global Strategy", desc: "Headquartered in Las Vegas, NV." }] },
    footer: { hotline: "Official Hotline: (702) 539-7575", hq: "Headquarters: 180 E NEAL AVE, Las Vegas, NV 89183, USA", privacy: "Privacy Policy", terms: "Terms of Service", contact: "Contact WHI", disclaimer1: "*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.", disclaimer2: "The information provided is for informational purposes only and does not establish a doctor-patient relationship.", rights: "World Help International Inc. (WHI). All rights reserved." }
  },
  zh: {
    nav: { science: "科学原理", benefits: "核心益处", ecosystem: "产品系列", quality: "品质与科学", company: "关于 WHI", order: "立即订购", switch: "EN" },
    hero: { badge: "AI赋能 · 双通路协同", title1: "细胞级", titleHighlight: "年轻态", title2: "全效配方", desc: "摒弃碎片化的噱头，直击生命基础特征——“代谢”。通过 AKG、NMN、NR 和 NAC 的黄金科学配比，支持源头活力。", btnOrder: "获取 AI AKG PLUS", btnQuiz: "参与专属匹配测试" },
    science: {
      title: "拒绝“非此即彼”的伪命题", desc: "打破行业内“抬高AKG、打压NMN”的认知局限。在细胞能量与修复网络中，两者相辅相成，缺一不可。",
      engines: [
        { title: "核心引擎 1：Ca-AKG", sub: "能量储备支持", color: "#10b981", points: ["TCA循环枢纽：支持天然 ATP 能量生成。", "表观遗传支持：帮助维护表观遗传特征的年轻态。", "组织健康：促进胶原蛋白合成，支持骨骼健康。"] },
        { title: "核心引擎 2：NMN & NR", sub: "细胞发电与传输", color: "#f59e0b", points: ["激活长寿蛋白 Sirtuins：支持细胞寿命通路。", "细胞完整性：为维护天然 DNA 稳态提供能量。", "优化线粒体功能：支持能量转化率，维持活力。"] }
      ]
    },
    quality: {
      title: "品质与科学透明度", desc: "我们坚信绝对的透明度。每一个批次都必须经过严格的第三方独立实验室检测，以确保纯度、效价和绝对的安全。",
      steps: [
        { title: "全球优选原料", desc: "我们在全球范围内甄选最高等级的原材料，并在配方生产前对真实性和活性进行严格核验。" },
        { title: "第三方 HPLC 检测", desc: "通过独立实验室的色谱分析验证，确保我们的核心成分始终满足 99%+ 的严苛纯度标准。" },
        { title: "无有害残留物", desc: "对重金属、微生物和过敏原进行深度筛查，为您提供零妥协的安全保障。" }
      ]
    },
    benefits: {
      title: "全方位的细胞级支持", desc: "AI大数据筛选，NAC细胞防线与专有肽类复合物的完美融合，覆盖五大健康维度。",
      items: [
        { title: "神经与睡眠", desc: "通过酸枣仁和枸杞提取物支持神经递质平衡，维护认知，促进安稳睡眠。", icon: Brain },
        { title: "细胞活力", desc: "支持健康的细胞微环境，帮助维护端粒完整性。", icon: Activity },
        { title: "能量与代谢", desc: "支持 ATP 生成，帮助动态维持全身代谢网络的平衡。", icon: Zap },
        { title: "心血管健康", desc: "支持血管弹性，提供强大的抗氧化防御体系。", icon: HeartPulse },
        { title: "肌肉与骨骼", desc: "支持肌肉活力，促进胶原蛋白合成，助力日常活动后的恢复。", icon: ShieldCheck }
      ]
    },
    ecosystem: {
      title: "DR. FARGO 系列产品矩阵", desc: "内调生命原动力，外养身体微循环，构筑全面的健康生活方式。", coreHub: "核心内调枢纽",
      products: [
        { img: "c4847fc64eb64258fe4316e35982abaa.jpg", title: "高能量吹风筒", desc: "远红外线技术释放生命光波" },
        { img: "c1861705bb8d6698e83eef8ceadb3c9a.jpg", title: "高能水活化片", desc: "深层活化水分子，促吸收" },
        { img: "624577b65a79ebb1eb0abf6b598472de.jpg", title: "光子能量排毒袋", desc: "支持全身微循环与健康维护" },
        { img: "6ad134ca90efd9a341fdeb20450014f8.png", title: "赋活面膜", desc: "深层细胞补水" },
        { img: "ceb922bf426544209c2fa588c474fd83.jpg", title: "能量鞋垫", desc: "足底穴位激发" }
      ]
    },
   video: { 
      title: "探索我们的愿景", 
      desc: "深入了解 DR. FARGO 背后的细胞科学，以及世界健康国际公司的全球布局。",
      vid1Title: "DR. FARGO AI AKG PLUS 产品解析",
      vid2Title: "World Health International 公司介绍" 
    },
    quiz: {
      step: "步骤", of: "/", completed: "已完成", resultTitle: "您是完美契合者！", btnUnlock: "立即解锁专属配方", btnRetake: "重新测试",
      q4Title: "告诉我们您具体的健康关注点？", q4Placeholder: "例如：希望维持精力，支持更好的睡眠...", btnGenerateAI: "✨ 生成您的专属 AI 分析报告", generating: "AI 正在分析您的细胞数据，制定专属方案...", aiResultTitle: "✨ 您的专属 AI 细胞分析报告", aiError: "AI 分析请求失败。我们已为您生成标准细胞级建议。",
      questions: [
        { q: "您健康保养的首要诉求是什么？", opts: ["提升日常精力与活力", "支持安稳的睡眠与认知能力", "日常机能恢复与关节支持", "全方位的细胞级活力维护"] },
        { q: "您是否经常感到午后疲惫？", opts: ["很少 - 我的精力一直很充沛", "偶尔 - 通常在下午会出现", "经常 - 已经影响到我的日常效率", "每天 - 我总是感觉疲惫不堪"] },
        { q: "您目前正在服用健康营养剂吗？", opts: ["是的，但每天吃好几种太麻烦了", "是的，但我希望能有更好的协同效果", "没有，我不知道该从何入手", "没有，我一直在等全能型的配方"] }
      ]
    },
    pricing: { 
      title: "投资您的细胞未来", 
      subtitle: "120 粒装 / 30 天用量",
      stock: "现货发售",
      features: [
        "Ca-AKG (1360 mg) + NMN/NR 双核驱动",
        "NAC 细胞防御支持体系",
        "专利多肽复合物",
        "靶向植物萃取精华"
      ],
      btnAdd: "前往 Stripe 安全结账",
      secure: "通过 Stripe 进行安全 SSL 加密支付"
    },
    company: { title: "World Help International Inc. 荣誉出品", desc: "传递健康 • 播种希望 • 分享爱。长寿时代下，WHI 正在重新定义全球健康生态系统。", boxTitle: "双核驱动：重新定义标准", boxDesc: "将内部生命原动力（AI AKG PLUS）与外部量子能量穿戴设备相结合。", features: [{ title: "FDA 标准智造中心", desc: "全自动化流水线，严格遵循 CGMP 规范。" }, { title: "立足美国，辐射全球", desc: "总部位于美国内华达州拉斯维加斯，强势赋能亚太、欧洲及拉美市场。" }] },
    footer: { hotline: "官方服务热线：(702) 539-7575", hq: "总部地址：180 E NEAL AVE, Las Vegas, NV 89183, USA", privacy: "隐私政策", terms: "服务条款", contact: "联系 WHI", disclaimer1: "*These statements have not been evaluated by the Food and Drug Administration. (以上声明未经美国食品药品监督管理局评估。本产品不用于诊断、治疗、治愈或预防任何疾病。)", disclaimer2: "本网站提供的信息仅供参考，不作为任何诊断或治疗的依据。", rights: "World Help International Inc. (WHI). 版权所有。" }
  }
};

export default function App() {
  const [lang, setLang] = useState('en');
  const t = translations[lang];
  
  const [quizStep, setQuizStep] = useState(0);
  const [quizAnswers, setQuizAnswers] = useState({});
  const [customConcern, setCustomConcern] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [aiReport, setAiReport] = useState(null);
  const [aiError, setAiError] = useState('');
  
  const pricingRef = useRef(null);

  const toggleLanguage = () => setLang(lang === 'zh' ? 'en' : 'zh');
  const scrollToPricing = () => pricingRef.current?.scrollIntoView({ behavior: 'smooth' });

  const resetQuiz = () => { 
    setQuizStep(0); setQuizAnswers({}); setCustomConcern(''); 
    setShowResult(false); setAiReport(null); setAiError('');
  };

  const handleQuizAnswer = (idx) => { 
    setQuizAnswers({...quizAnswers, [quizStep]: idx}); 
    setQuizStep(quizStep + 1); 
  };

  const generateAIReport = async () => {
    setShowResult(true);
    setIsGenerating(true);
    setAiError('');

    const promptLanguage = lang === 'zh' ? 'Simplified Chinese' : 'English';
    const ans1 = t.quiz.questions[0].opts[quizAnswers[0]] || 'Not specified';
    const ans2 = t.quiz.questions[1].opts[quizAnswers[1]] || 'Not specified';
    const ans3 = t.quiz.questions[2].opts[quizAnswers[2]] || 'Not specified';
    const concern = customConcern.trim() || 'None provided';

    const promptText = `You are a professional cellular health consultant for DR. FARGO. User answers: 1) Focus: ${ans1}. 2) Fatigue: ${ans2}. 3) Supplements: ${ans3}. Specific concerns: ${concern}. Generate a highly personalized 2-paragraph analysis in ${promptLanguage}. Para 1: Empathetically address their specific answers/concerns, explaining the underlying cellular mechanisms. Para 2: Explain why DR. FARGO AI AKG PLUS supports their specific needs, avoiding medical or disease-curing claims. Write clearly and professionally. Do not use markdown headers. Keep it to exactly two paragraphs.`;

    try {
      if (apiKey === "" || !apiKey) throw new Error("API Key not set.");
      const url = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${apiKey}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contents: [{ parts: [{ text: promptText }] }] })
      });
      if (!response.ok) throw new Error('API Request Failed');
      const result = await response.json();
      const generatedText = result.candidates?.[0]?.content?.parts?.[0]?.text;
      if (generatedText) {
        setAiReport(generatedText.split('\n').filter(p => p.trim() !== ''));
      } else {
        throw new Error('No content returned');
      }
    } catch (err) {
      console.error(err);
      setAiError(t.quiz.aiError);
    } finally {
      setIsGenerating(false);
    }
  };

  const styles = {
    btnEmerald: { backgroundColor: '#059669', color: 'white', padding: 'clamp(10px, 2vw, 12px) clamp(16px, 3vw, 24px)', borderRadius: '30px', fontWeight: 'bold', border: 'none', cursor: 'pointer', boxShadow: '0 4px 15px rgba(5,150,105,0.3)', whiteSpace: 'nowrap' },
    btnAmber: { backgroundColor: '#f59e0b', color: '#000', padding: 'clamp(12px, 3vw, 18px) clamp(24px, 5vw, 40px)', borderRadius: '40px', fontWeight: '800', fontSize: 'clamp(16px, 3vw, 18px)', border: 'none', cursor: 'pointer', boxShadow: '0 10px 25px rgba(245,158,11,0.4)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '10px', width: '100%' },
    glassPanel: { backgroundColor: 'rgba(255, 255, 255, 0.1)', backdropFilter: 'blur(12px)', border: '1px solid rgba(255, 255, 255, 0.2)', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '40px', width: '100%', maxWidth: '400px' },
    cardWhite: { backgroundColor: 'white', borderRadius: '24px', padding: 'clamp(20px, 5vw, 40px)', boxShadow: '0 20px 40px rgba(0,0,0,0.05)' },
    sectionPadding: { padding: 'clamp(60px, 10vw, 120px) 20px' }
  };

  return (
    <main style={{ backgroundColor: '#f8fafc', color: '#0f172a', minHeight: '100vh', fontFamily: 'system-ui, -apple-system, sans-serif', margin: 0, padding: 0, overflowX: 'hidden' }}>
      <style>{`
        .hide-on-mobile { display: flex; }
        .hero-buttons { flex-direction: row; }
        @media (max-width: 640px) {
          .hide-on-mobile { display: none !important; }
          .hero-buttons { flex-direction: column; width: 100%; }
        }
      `}</style>

      {/* Navbar */}
      <nav aria-label="Main Navigation" style={{ position: 'sticky', top: 0, backgroundColor: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(10px)', zIndex: 100, borderBottom: '1px solid #e2e8f0', padding: '15px 20px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span aria-label="DR. FARGO Logo" style={{ fontSize: 'clamp(20px, 4vw, 26px)', fontWeight: '900', color: '#064e3b', letterSpacing: '-0.5px' }}>DR. FARGO<sup style={{fontSize:'0.5em'}}>™</sup></span>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <button onClick={toggleLanguage} aria-label={`Switch language`} style={{ backgroundColor: '#ecfdf5', border: '1px solid #d1fae5', padding: '8px 12px', borderRadius: '20px', color: '#047857', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}><Globe2 size={16} aria-hidden="true"/> <span className="hide-on-mobile">{t.nav.switch}</span></button>
            <button onClick={scrollToPricing} aria-label="Order" style={styles.btnEmerald}>{t.nav.order}</button>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <header style={{ background: 'linear-gradient(135deg, #064e3b 0%, #0d9488 100%)', color: 'white', padding: 'clamp(60px, 10vw, 100px) 20px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '40px' }}>
          <div style={{ flex: '1', minWidth: '280px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: 'rgba(255,255,255,0.15)', padding: '8px 20px', borderRadius: '30px', fontSize: '14px', marginBottom: '25px', fontWeight: '600' }}><Microscope size={16} aria-hidden="true"/> {t.hero.badge}</div>
            <h1 style={{ fontSize: 'clamp(36px, 6vw, 56px)', fontWeight: '900', lineHeight: 1.2, marginBottom: '25px' }}>{t.hero.title1} <br/><span style={{ color: '#fbbf24' }}>{t.hero.titleHighlight}</span> {t.hero.title2}</h1>
            <p style={{ fontSize: 'clamp(16px, 3vw, 20px)', opacity: 0.9, marginBottom: '40px', maxWidth: '550px', lineHeight: 1.6 }}>{t.hero.desc}</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '15px' }}>
              <button onClick={scrollToPricing} style={{...styles.btnAmber, width: 'auto', flex: 1}}>{t.hero.btnOrder} <ArrowRight size={20}/></button>
              <button onClick={() => document.getElementById('quiz').scrollIntoView({behavior: 'smooth'})} style={{ backgroundColor: 'rgba(255,255,255,0.1)', border: '2px solid rgba(255,255,255,0.3)', color: 'white', padding: '15px 30px', borderRadius: '40px', fontWeight: 'bold', fontSize: 'clamp(16px, 3vw, 18px)', cursor: 'pointer', flex: 1 }}>{t.hero.btnQuiz}</button>
            </div>
          </div>
          <div style={{ flex: '1', minWidth: '280px', display: 'flex', justifyContent: 'center' }}>
            <div style={styles.glassPanel}>
              <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '30px', aspectRatio: '3/4', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src="/product1.jpg" alt="Product" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/400x600/e2e8f0/64748b?text=DR.+FARGO+AI+AKG+PLUS"; }} />
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Science */}
      <section id="science" style={styles.sectionPadding}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 style={{ fontSize: 'clamp(28px, 5vw, 36px)', fontWeight: '900' }}>{t.science.title}</h2>
            <p style={{ color: '#64748b' }}>{t.science.desc}</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
            {t.science.engines.map((engine, idx) => (
              <div key={idx} style={{ backgroundColor: '#f8fafc', padding: '30px', borderRadius: '30px', border: '1px solid #e2e8f0' }}>
                <h3 style={{ fontSize: '20px', fontWeight: 'bold' }}>{engine.title}</h3>
                <p style={{ color: engine.color, fontWeight: 'bold' }}>{engine.sub}</p>
                <ul style={{ listStyle: 'none', padding: 0, marginTop: '20px' }}>
                  {engine.points.map((pt, i) => (
                    <li key={i} style={{ display: 'flex', gap: '10px', marginBottom: '15px', color: '#475569' }}><CheckCircle2 size={20} color={engine.color} style={{flexShrink:0}}/> {pt}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" style={{ ...styles.sectionPadding, backgroundColor: '#064e3b', color: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 style={{ fontSize: 'clamp(28px, 5vw, 36px)', fontWeight: '900', color: '#fbbf24' }}>{t.benefits.title}</h2>
            <p style={{ color: '#a7f3d0' }}>{t.benefits.desc}</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            {t.benefits.items.map((item, idx) => {
              const IconComponent = item.icon;
              return (
                <div key={idx} style={{ backgroundColor: 'rgba(255,255,255,0.1)', padding: '30px', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.2)' }}>
                  <IconComponent color="#fbbf24" size={32} style={{ marginBottom: '15px' }} />
                  <h4 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '15px', color: '#fbbf24' }}>{item.title}</h4>
                  <p style={{ fontSize: '15px', color: '#d1fae5', lineHeight: 1.6 }}>{item.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Ecosystem Section */}
      <section id="ecosystem" style={{ ...styles.sectionPadding, backgroundColor: '#f8fafc' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 style={{ fontSize: 'clamp(28px, 5vw, 36px)', fontWeight: '900', color: '#0f172a' }}>{t.ecosystem.title}</h2>
            <p style={{ color: '#64748b' }}>{t.ecosystem.desc}</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '30px' }}>
            {t.ecosystem.products.map((prod, idx) => (
              <div key={idx} style={{ backgroundColor: 'white', padding: '30px', borderRadius: '30px', textAlign: 'center', border: '1px solid #e2e8f0', boxShadow: '0 10px 20px rgba(0,0,0,0.03)' }}>
                <div style={{ width: '100%', height: '180px', backgroundColor: '#f8fafc', borderRadius: '20px', marginBottom: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                  <img src={prod.img} alt={prod.title} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/400x300/e2e8f0/64748b?text=DR.+FARGO+Ecosystem"; }} />
                </div>
                <h4 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1e293b' }}>{prod.title}</h4>
                <p style={{ fontSize: '14px', color: '#64748b', marginTop: '10px' }}>{prod.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quality Section */}
      <section style={{ ...styles.sectionPadding, backgroundColor: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 style={{ fontSize: '36px', fontWeight: '900' }}>{t.quality.title}</h2>
            <p style={{ color: '#64748b' }}>{t.quality.desc}</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
            {t.quality.steps.map((step, idx) => (
              <div key={idx} style={{ backgroundColor: '#f8fafc', padding: '40px', borderRadius: '30px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
                <div style={{ width: '60px', height: '60px', backgroundColor: '#ecfdf5', borderRadius: '50%', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <ShieldCheck color="#10b981" />
                </div>
                <h4 style={{ fontWeight: 'bold', fontSize: '20px', marginBottom: '10px' }}>{step.title}</h4>
                <p style={{ color: '#64748b', fontSize: '15px' }}>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

     {/* Video Section */}
      <section style={{ padding: '80px 20px', backgroundColor: '#f1f5f9' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 'clamp(28px, 5vw, 36px)', fontWeight: '900', marginBottom: '15px' }}>{t.video.title}</h2>
          <p style={{ color: '#64748b', marginBottom: '50px' }}>{t.video.desc}</p>
          
          {/* 双视频网格布局 */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '40px' }}>
            
            {/* 第一个视频：DR. FARGO 产品 */}
            <div>
              <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '15px', color: '#0f172a' }}>{t.video.vid1Title}</h3>
              <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '24px', boxShadow: '0 20px 40px rgba(0,0,0,0.15)' }}>
                <iframe
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                  src="https://www.youtube.com/embed/YOjPNarx2Xw" 
                  title="DR. FARGO Video" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* 第二个视频：WHI 公司介绍 */}
            <div>
              <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '15px', color: '#0f172a' }}>{t.video.vid2Title}</h3>
              <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '24px', boxShadow: '0 20px 40px rgba(0,0,0,0.15)' }}>
                <iframe
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                  src="https://www.youtube.com/embed/Ol-nBtK5ZGM" 
                  title="Company Introduction Video" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                ></iframe>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Quiz Section */}
      <section id="quiz" style={styles.sectionPadding}>
        <div style={{ maxWidth: '800px', margin: '0 auto', ...styles.cardWhite }}>
          {!showResult ? (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: '#059669', fontWeight: 'bold', marginBottom: '20px' }}>
                <span>{t.quiz.step} {quizStep + 1} {t.quiz.of} 4</span>
              </div>
              {quizStep < 3 ? (
                <div>
                  <h3 style={{ fontSize: 'clamp(22px, 4vw, 28px)', fontWeight: '900', marginBottom: '30px' }}>{t.quiz.questions[quizStep].q}</h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    {t.quiz.questions[quizStep].opts.map((opt, i) => (
                      <button key={i} onClick={() => handleQuizAnswer(i)} style={{ textAlign: 'left', padding: '20px', borderRadius: '15px', border: '2px solid #e2e8f0', fontSize: '18px', fontWeight: '600', backgroundColor: 'white', cursor: 'pointer' }}>{opt}</button>
                    ))}
                  </div>
                </div>
              ) : (
                <div>
                  <h3 style={{ fontSize: '28px', fontWeight: '900' }}>{t.quiz.q4Title}</h3>
                  <textarea style={{ width: '100%', padding: '20px', borderRadius: '15px', border: '2px solid #cbd5e1', height: '150px', marginTop: '20px', resize: 'none' }} placeholder={t.quiz.q4Placeholder} value={customConcern} onChange={(e) => setCustomConcern(e.target.value)} />
                  <button onClick={generateAIReport} style={{ ...styles.btnAmber, marginTop: '20px' }}><Sparkles size={20} /> {t.quiz.btnGenerateAI}</button>
                </div>
              )}
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              {isGenerating ? (
                <div style={{ padding: '60px' }}><Loader2 size={60} color="#10b981" style={{ margin: '0 auto', animation: 'spin 2s linear infinite' }} /><h3>{t.quiz.generating}</h3></div>
              ) : (
                <div style={{ textAlign: 'left' }}>
                  <h3 style={{ fontSize: '32px', fontWeight: '900', color: '#064e3b', textAlign: 'center' }}>{t.quiz.resultTitle}</h3>
                  


                  <div style={{ backgroundColor: '#f0fdf4', padding: '30px', borderRadius: '20px', marginTop: '20px' }}>
                    <h4 style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px', color: '#064e3b' }}>
                      <Sparkles color="#f59e0b" /> {t.quiz.aiResultTitle}
                    </h4>
                    
                    {aiReport ? (
                      aiReport.map((p, i) => <p key={i} style={{ marginTop: '10px', lineHeight: 1.8, color: '#334155' }}>{p}</p>)
                    ) : (
                      <>
                        <p style={{ lineHeight: 1.8, color: '#334155', marginBottom: '10px' }}>
                          {lang === 'zh' 
                            ? '根据您的健康档案，您的细胞代谢需要一种多通路的协同支持方案。' 
                            : 'Based on your profile, your cellular metabolism requires a synergistic approach.'}
                        </p>
                        <p style={{ lineHeight: 1.8, color: '#334155' }}>
                          {lang === 'zh' 
                            ? 'DR. FARGO AI AKG PLUS 通过 Ca-AKG (1360mg) 的表观遗传支持与 NMN/NR 的直接能量补充相结合，完美契合您的核心健康诉求。' 
                            : 'DR. FARGO AI AKG PLUS targets your specific needs by combining Ca-AKG (1360mg) for epigenetic remodeling with NMN/NR for direct energy replenishment.'}
                        </p>
                      </>
                    )}
                  </div>
                  
                  <div style={{ display: 'flex', gap: '15px', marginTop: '30px', justifyContent: 'center' }}>
                    <button onClick={scrollToPricing} style={{ ...styles.btnAmber, width: 'auto' }}>{t.quiz.btnUnlock}</button>
                    <button onClick={resetQuiz} style={{ padding: '15px 30px', borderRadius: '40px', border: '1px solid #cbd5e1', backgroundColor: 'white', cursor: 'pointer' }}>{t.quiz.btnRetake}</button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      {/* Pricing Section */}
      <section ref={pricingRef} style={styles.sectionPadding}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', backgroundColor: '#0f172a', borderRadius: '40px', display: 'flex', flexWrap: 'wrap', overflow: 'hidden' }}>
          <div style={{ flex: '1.5', minWidth: '280px', padding: '60px', color: 'white' }}>
            <h3 style={{ fontSize: '36px', fontWeight: '900' }}>{t.pricing.title}</h3>
            <p style={{ color: '#fbbf24', fontWeight: 'bold' }}>{t.pricing.subtitle}</p>
            <div style={{ fontSize: '64px', fontWeight: '900', margin: '20px 0' }}>$138 <span style={{ fontSize: '20px', opacity: 0.6 }}>USD</span></div>
            <ul style={{ listStyle: 'none', padding: 0, marginBottom: '40px' }}>
              {t.pricing.features.map((f, i) => <li key={i} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}><CheckCircle2 color="#fbbf24" size={20}/> {f}</li>)}
            </ul>
            
            {/* Free Shipping Tag */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '20px', padding: '10px', backgroundColor: 'rgba(16,185,129,0.2)', border: '1px solid #10b981', borderRadius: '12px', color: '#34d399', fontWeight: 'bold' }}>
              <Zap size={18} /> <span>{lang === 'zh' ? '全美限时免邮' : 'Limited Time Free Shipping (Continental US)'}</span>
            </div>

            <button onClick={() => window.location.href = 'https://buy.stripe.com/fZubJ15F23RTh1XfeLf7i00'} style={{ ...styles.btnAmber, width: '100%' }}>{t.pricing.btnAdd} — $138</button>
            <p style={{ textAlign: 'center', fontSize: '12px', marginTop: '15px', color: '#94a3b8' }}>{t.pricing.secure}</p>
          </div>
          <div style={{ flex: '1', minWidth: '280px', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
            <img src="/product1.jpg" alt="Bottle" style={{ maxHeight: '350px', objectFit: 'contain' }} onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/400x600/e2e8f0/64748b?text=DR.+FARGO+AI+AKG+PLUS"; }} />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ backgroundColor: '#0f172a', color: '#94a3b8', padding: '100px 20px 40px', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ fontSize: '32px', fontWeight: '900', color: 'white', marginBottom: '30px' }}>DR. FARGO<sup style={{fontSize:'12px'}}>™</sup></div>
          <p style={{ marginBottom: '20px' }}>{t.footer.hq}</p>
          <button style={{ ...styles.btnEmerald, backgroundColor: 'rgba(16,185,129,0.15)', border: '1px solid #059669', color: '#34d399' }} onClick={() => window.location.href='tel:7025397575'}><Phone size={20} /> {t.footer.hotline}</button>
          <div style={{ marginTop: '80px', paddingTop: '40px', borderTop: '1px solid #1e293b', fontSize: '13px' }}>
            <p style={{ color: '#cbd5e1', fontWeight: 'bold', marginBottom: '10px' }}>{t.footer.disclaimer1}</p>
            <p>{t.footer.disclaimer2}</p>
            <p style={{ marginTop: '20px' }}>© {new Date().getFullYear()} {t.footer.rights}</p>
          </div>
        </div>
      </footer>
    </main>
  );
}